import { SkillShikshyaIcon } from "@assets/icons";
import { Button } from "@components/ui/button";
import { Spinner } from "@components/ui/spinner";
import { InvoiceData, UserData } from "@utils/interface/journey.interface";
import React, { useActionState, useState, useTransition } from "react";

type Props = {
  data: any;
  invoice: InvoiceData | Partial<InvoiceData>;
  ref: React.RefObject<HTMLDivElement | null> | null;
};

const PreviewCard: React.FC<Props> = ({ data, ref, invoice }: Props) => {
  const { email, full_name, phone } = data;
  return (
    <>
      <>{/* <InvCard /> */}</>

      <div
        ref={ref}
        id="print-section"
        className="max-w-4xl mx-auto p-[30px] bg-white shadow rounded-2xl"
      >
        <div className="flex justify-between items-start mb-8">
          <div className="w-fit h-32 p-4 bg-gray-100 rounded-lg flex items-center justify-center">
            <div className="text-center">
              <div className="text-green-600 font-bold text-lg mb-1">
                <SkillShikshyaIcon />
              </div>
            </div>
          </div>

          <div className="text-right">
            <h1 className="text-[32px] font-bold text-gray-900 mb-2">
              Invoice
            </h1>
            <div className="text-[12px] text-gray-600 space-y-1">
              <div>
                Invoice No.: <strong>{invoice.invoice_no}</strong>
              </div>
              <div>
                Invoice Date: <strong>{invoice.created_date}</strong>
              </div>
            </div>
          </div>
        </div>

        {/* Billing Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 text-[12px]">
          <div>
            <h3 className="font-semibold text-gray-900 mb-3">Billed To</h3>
            <div className="text-gray-700 space-y-1">
              <div className="font-medium">{full_name}</div>
              <div>{email}</div>
              <div>{phone}</div>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-3">From</h3>
            <div className="text-gray-700 space-y-1">
              <div className="font-medium">Skillshikshya</div>
              <div>info@skillshikshya.com</div>
              <div>(+977) 985-852-9621</div>
            </div>
          </div>
        </div>

        {/* Course Details Table */}
        <div className="mb-8  text-[12px]">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-3 font-semibold text-gray-900">
                    Course
                  </th>
                  <th className="text-right py-3 font-semibold text-gray-900">
                    Total Amount
                  </th>
                  <th className="text-right py-3 font-semibold text-gray-900">
                    Paid Amount
                  </th>
                  <th className="text-right py-3 font-semibold text-gray-900">
                    Discount
                  </th>
                  <th className="text-right py-3 font-semibold text-gray-900">
                    Due Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-100">
                  <td className="py-4">
                    <div className="font-medium text-gray-900">
                      {invoice?.course_batch?.course?.title}
                    </div>
                    <div className="text-sm text-gray-600">
                      {invoice?.course_batch?.name}
                    </div>
                  </td>
                  <td className="text-right py-4 text-gray-700">
                    NRs. {invoice.total_amount}
                  </td>
                  <td className="text-right py-4 text-gray-700">
                    NRs. {invoice.paid_amount}
                  </td>
                  <td className="text-right py-4 text-gray-700">
                    NRs. {invoice?.discount || "0.00"}
                  </td>
                  <td className="text-right py-4 text-gray-700">
                    NRs. {invoice.due_amount || "0.00"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Total */}
          <div className="flex justify-end mt-4 pt-4 border-t border-gray-200">
            <div className="text-right">
              <div className="flex justify-between items-center gap-8">
                <span className="font-semibold text-gray-900">
                  Due Amount Total
                </span>
                <span className="font-bold text-lg text-gray-900">
                  NRs. {invoice.due_amount}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mb-8 ">
          <p className="text-gray-600 text-sm mb-6 max-w-2xl mx-auto">
            Please review the details above and ensure they are correct. If any
            information needs to be updated, reply to this email with the
            corrected details.
          </p>
        </div>
      </div>
    </>
  );
};

export default PreviewCard;

const InvCard = () => {
  const [data, setData] = useState<any>();
  const [isPending, startTransistion] = useTransition();

  const handlePayment = () => {
    startTransistion(async () => {
      let fatchData = await fetch("https://base.skillshikshya.com/api/level/");
      const newData = await fatchData.json();
      console.log("🚀 ~ startTransistion ~ newData:", newData);
      setData(() => newData);
    });
  };
  return (
    <>
      <Button onClick={handlePayment} endIcon={isPending ? <Spinner /> : null}>
        Make payment
      </Button>
      {JSON.stringify(data)}
    </>
  );
};
